import * as React from 'react'

import { IPermitTypeField } from '~/client/graph'
import { IDrillDownFilterCategory } from '~/client/src/shared/components/DrillDownFilter/DrillDownFilter.types'
import type { IOptionItem } from '~/client/src/shared/components/OptionsList/types'
import SortOrder from '~/client/src/shared/enums/SortOrder'

export type ResourceDefaultsPopupType = 'sort' | 'groupBy' | 'filters' | null

interface IResourceFieldContext {
  field: IPermitTypeField
  resourceTypeId: string
  onChange: (updatedField: IPermitTypeField) => void
  sortOptions: IOptionItem[]
  groupByOptions: IOptionItem[]
  filterCategories: IDrillDownFilterCategory<{ id: string; label: string }>[]

  // Defaults state
  sortKey: string | null
  sortOrder: SortOrder
  groupByKey: string | null
  filterSelection: string[]
  activePopup: ResourceDefaultsPopupType
  hasSortDefaults: boolean
  hasGroupByDefaults: boolean
  hasFilterDefaults: boolean

  // Defaults actions
  setSortDefaults: (key: string | null, order: SortOrder) => void
  setGroupByDefault: (key: string | null) => void
  setFilterDefaults: (selection: string[]) => void
  setAllDefaults: (
    sortKey: string | null,
    sortOrder: SortOrder,
    groupByKey: string | null,
    filterSelection: string[],
  ) => void
  togglePopup: (popup: ResourceDefaultsPopupType) => void
  closePopup: () => void
  resetDefaults: () => void
}

export const ResourceFieldContext =
  React.createContext<IResourceFieldContext | null>(null)

export function useResourceFieldContext(): IResourceFieldContext {
  const ctx = React.useContext(ResourceFieldContext)
  if (!ctx) {
    throw new Error(
      'useResourceFieldContext must be used inside ResourceFieldConfigurator',
    )
  }
  return ctx
}
